import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

class SectionTickerTape extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.carousel = this.querySelector("[data-ticker-tape]");
    this.initFunction();
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", (event) => {
        this.initFunction();
      });
    }
  }

  initFunction() {
    if (!this.carousel) return;

    const options = {
      type: "loop",
      arrows: false,
      pagination: false,
      drag: "free",
      gap: "100px",
      autoWidth: true,
      easing: "linear",
      autoScroll: {
        speed: this.data.scrollSpeedDesktop,
      },
      breakpoints: {
        992: {
          gap: "40px",
          autoScroll: {
            speed: this.data.scrollSpeedMobile,
          },
        },
      },
    };

    this.splide = new Splide(this.carousel, options).mount({ AutoScroll });
  }
}

if (!customElements.get("section-ticker-tape")) {
  customElements.define("section-ticker-tape", SectionTickerTape);
}
